import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
interface ThankYouDialogProps {
  open: any;
  onClose: any;
}

const ThankYouDialog: React.FC<ThankYouDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          padding: { xs: "0.5rem !important", sm: "1rem" },
        },
      }}
      sx={{
        zIndex: 10010,
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontSize: "28px !important",
          fontWeight: "500 !important",
        }}
      >
        Thank You for Your Payment!
      </DialogTitle>
      <DialogContent>
        <Box textAlign="center" marginBottom={2} sx={{ margin: "1rem auto" }}>
          <CheckCircleIcon
            sx={{ fontSize: { xs: "4rem", sm: "6rem" }, color: "#15741a" }}
          />
        </Box>
        <Typography
          variant="body1"
          sx={{ margin: "auto", textAlign: "center" }}
        >
          Your payment has been successfully processed. We appreciate your
          support and look forward to serving you again!
        </Typography>
      </DialogContent>
      <DialogActions sx={{ margin: "auto", textAlign: "center" }}>
        <Button variant="outlined" color="success" onClick={onClose}>
          close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ThankYouDialog;
